import { render } from "./PageTop.vue?vue&type=template&id=6d5043b3&scoped=true"
import script from "./PageTop.vue?vue&type=script&lang=js"
export * from "./PageTop.vue?vue&type=script&lang=js"

import "./PageTop.vue?vue&type=style&index=0&id=6d5043b3&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-6d5043b3"

export default script